module.exports = __webpack_public_path__ + "static/media/WALLET_STATEMENT.b824a59d.svg";